import { OBJECT_SCREEN_TAB_SEARCH_PARAM } from '@components/v2/layout/ObjectScreen/objectScreen.constants';
import useSearchParams from '../../../../../hooks/useSearchParams';
import { useOrderTargets } from '../../../../../services/modules/target/target.queries';
import { useFeatureVisibility } from '../../../../permissions/contexts/FeatureVisibilityContext';
import { F } from '../../../../permissions/types/features.keys';
import { StatusType } from '../../../order.types';
import { ORDER_OBJECT_TAB } from '../../../orders.constants';
import { UseOrderObjectTargetsTabSummaryParams } from '../orderObjectPage.types';
import useHasBrandTargets from './useHasBrandTargets';

const useOrderObjectTargetsTabSummary = ({
  orderId,
  status,
}: UseOrderObjectTargetsTabSummaryParams) => {
  const { isVisible: isFeatureVisible } = useFeatureVisibility();
  const { searchParams } = useSearchParams();
  const isAllowed =
    !!orderId && status !== StatusType.SUGGESTED && isFeatureVisible(F.targets.viewOrderTargets);
  const { hasTargets, hasFailed, isLoading } = useHasBrandTargets({ enabled: isAllowed });
  const isTabRequested = searchParams[OBJECT_SCREEN_TAB_SEARCH_PARAM] === ORDER_OBJECT_TAB.TARGETS;
  const isRequestedTabLoading = isLoading && isTabRequested;
  const hasNoAnswer = hasFailed || isRequestedTabLoading;
  const isVisible = isAllowed && (hasTargets || hasNoAnswer);
  const { data } = useOrderTargets(orderId ?? '', { enabled: isVisible });

  return { isVisible, count: data?.length };
};

export default useOrderObjectTargetsTabSummary;
